<template>
  <p class="text">
    <InfoCircleOutlined /> Recuerda que si realizas cambios, todos tus dashboards y datos asociados
    serán actualizados.
  </p>
</template>

<script>
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    InfoCircleOutlined,
  },
});
</script>

<style lang="sass" scoped>
.text
    font-weight: 600
    font-size: 12px
    display: flex
    font-style: italic
    font-weight: 400
    .anticon
        margin: 3px 5px 0 0
</style>
